import { Component, OnInit, Input, HostListener, Output, EventEmitter, AfterViewInit, ViewChild } from '@angular/core';
import { RequestType } from '@app/shared/types';
import { ServicePublicList } from '@app/shared/services/service-public-list';
import { TcServiceService } from '@app/shared/services';
import { take, finalize } from 'rxjs';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { TableLoadingComponent } from '../../table-loading/table-loading.component';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'tc-request-select-digital-currency',
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatRadioModule,
        TableLoadingComponent,
        MatExpansionModule,
        MatButtonModule,
        RouterLink,
        FormsModule
    ],
    templateUrl: './request-select-digital-currency.component.html',
    styleUrls: ['./request-select-digital-currency.component.scss']
})
export class RequestSelectDigitalCurrencyComponent implements OnInit, AfterViewInit {
  @Output() selectedServiceEmit = new EventEmitter<ServicePublicList>();

  @Input() requestType: RequestType;
  @Input() isWithdrawal: boolean;

  @ViewChild('expansionPanelElement') expansionPanelElement: MatExpansionPanel;

  // data
  services: ServicePublicList[];
  subServices: ServicePublicList[];
  selectedService: ServicePublicList;


  // boolean
  servicesIsLoading: boolean;

  // style
  disableExpansionPanel: boolean;

  constructor(
    private tcServiceService: TcServiceService
  ) { }


  /*******************************************************************
   LIFECYCLE HOOKES
   *******************************************************************/

  ngOnInit() {
    this.fetchServices();
  }

  ngAfterViewInit(): void {
    this.onResize(null);
  }

  /*******************************************************************
  services
  *******************************************************************/

  clickService(service: ServicePublicList): void {
    if (service.hasSubService) {
      // hide all card sub services
      this.services.forEach(el => {
        try {
          el['showSubService'] = false;
        } catch (ex) { }
      });

      // show sub services of this card
      service['showSub'] = true;

      this.selectedService = null;
      return;
    }
    this.selectedService = service;
    this.selectService();

  }

  selectService(): void {
    this.selectedServiceEmit.emit(this.selectedService);
  }

  hideSubService(service: ServicePublicList): void {
    service['showSub'] = false;
    this.selectedService = null;
  }

  /*******************************************************************
  Fetch
  *******************************************************************/

  private fetchServices(): void {
    this.servicesIsLoading = true;
    this.tcServiceService.getForReceive()
      .pipe(
        take(1),
        finalize(() => {
          this.servicesIsLoading = false;
        })
      )
      .subscribe(
        res => {
          this.services = res;
        }
      );
  }

  /*******************************************************************
  Styles
  *******************************************************************/

  @HostListener('window:resize', ['$event'])
  onResize(event) {

    if (window.innerWidth < 768) {
      this.disableExpansionPanel = false;

    } else if (!this.expansionPanelElement.disabled) {

      this.disableExpansionPanel = true;
      this.expansionPanelElement.open();
    }
  }

}
